"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionProviderImpl = void 0;
var Utils_1 = require("../../../utils/Utils");
var FirebaseUtils_1 = require("./../../firebase/FirebaseUtils");
var uuid_1 = require("uuid");
var firebase_1 = require("firebase");
var Future_1 = require("../../../utils/Future");
var UserCache_1 = require("./../../UserCache");
var DataSyncProviderImpl_1 = require("./DataSyncProviderImpl");
var CoreServiceHelper_1 = require("../airabbi/CoreServiceHelper");
var QuestionProviderImpl = (function () {
    function QuestionProviderImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.getTimeString)(), " QuestionServiceImpl#")], args, false));
            }
        };
        this.log('QuestionProviderImpl# created!');
        this.dataSyncProvider = new DataSyncProviderImpl_1.DataSyncProviderImpl(cfg);
    }
    QuestionProviderImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        return Promise.resolve();
    };
    QuestionProviderImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
    };
    QuestionProviderImpl.prototype.createComment = function (courseId, lessonId, exerciseId, studentId, questionId, commentType, content, resUrl, teachers, question) {
        var _this = this;
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!lessonId || lessonId.trim().length === 0) {
            return Promise.reject('lessonId cannot be empty!');
        }
        if (!exerciseId || exerciseId.trim().length === 0) {
            return Promise.reject('exerciseId cannot be empty!');
        }
        if (!studentId || studentId.trim().length === 0) {
            return Promise.reject('studentId cannot be empty!');
        }
        if (!questionId || questionId.trim().length === 0) {
            return Promise.reject('questionId cannot be empty!');
        }
        if (!commentType || commentType.trim().length === 0) {
            return Promise.reject('commentType cannot be empty!');
        }
        if (!content || content.trim().length === 0) {
            return Promise.reject('content cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var comment = {
            id: (0, uuid_1.v4)(),
            commentType: commentType,
            questionId: questionId,
            sender: { uid: currentUser.uid, displayName: currentUser.displayName },
            content: content,
            resUrl: resUrl ? resUrl : '',
            updated: firebase_1.default.database.ServerValue.TIMESTAMP,
            read: false
        };
        this.log('createComment#', comment);
        this.log('createComment# teachers:', teachers);
        this.log('createComment# question:', question);
        this.log('createComment# content:', content);
        this.log('createComment# studentId:', studentId);
        var path = "/units/".concat(currentUser.unit, "/question-comments/").concat(courseId, "/").concat(studentId, "/").concat(questionId, "/").concat(comment.id);
        this.log('createComment# path:', path);
        return (0, FirebaseUtils_1.setNode)(path, comment)
            .then(function () {
            _this.log('createComment#', 'created!');
            var questionLastUpdated = "/units/".concat(currentUser.unit, "/questions/").concat(courseId, "/").concat(studentId, "/").concat(question.id, "/lastUpdated");
            (0, FirebaseUtils_1.setNode)(questionLastUpdated, firebase_1.default.database.ServerValue.TIMESTAMP)
                .then(function () {
                _this.log('createComment#', 'update question lastUpdated successfully!');
            })
                .catch(function (err) {
                _this.log('createComment# err:', err);
            });
            var questionUpdateUserPath = "/units/".concat(currentUser.unit, "/questions/").concat(courseId, "/").concat(studentId, "/").concat(question.id, "/updateUser");
            (0, FirebaseUtils_1.setNode)(questionUpdateUserPath, {
                uid: currentUser.uid,
                displayName: currentUser.displayName,
                role: currentUser.role,
                email: currentUser.email
            })
                .then(function () {
                _this.log('createComment#', 'update question updateUser successfully!');
            })
                .catch(function (err) {
                _this.log('createComment# err:', err);
            });
            if (currentUser.uid === studentId && teachers && question && content) {
                _this.sendNotificationToTeachers(currentUser, teachers, question, content);
            }
            else if (currentUser.uid !== studentId && teachers && question && content) {
                _this.sendNotificationToStudentAndOtherTeachers(currentUser, teachers, question, content);
            }
            return _this.updateQuestionUnreadCount(courseId, studentId, questionId);
        })
            .catch(function (err) { return Promise.reject(err); });
    };
    QuestionProviderImpl.prototype.sendNotificationToTeachers = function (sender, teachers, question, comment) {
        var _this = this;
        this.log('sendNotificationToTeachers#', sender);
        this.log('sendNotificationToTeachers#', teachers);
        this.log('sendNotificationToTeachers#', question);
        this.log('sendNotificationToTeachers#', comment);
        CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .sendEmail(teachers, "\u5B78\u751F ".concat(sender.displayName, " \u56DE\u8986\u4E86 \u554F\u984C[").concat(question.title, "]"), "<div>\u767C\u554F\u8005:".concat(sender.displayName, "</div>") +
            "<div>\u767C\u554F\u8005 Email:".concat(sender.email, "</div><p/>") +
            "<div>\u554F\u984C\u50B3\u9001\u9580:<br/>https://app.codingbar.ai/question/".concat(question.courseId, "/").concat(sender.uid, "/").concat(question.id, "</div><p/>") +
            "<div>\u8AB2\u7A0B: ".concat(question.courseInfo.courseTitle, "</div><p/>") +
            "<div>\u554F\u984C\u6A19\u984C:<br/>".concat(question.title, "</div><p/>") +
            "<div>\u554F\u984C\u5167\u5BB9:<br/>".concat(question.content, "</div>") +
            "<div>\u56DE\u8986\u8A0A\u606F:<br/>".concat(comment, "</div>"))
            .then(function (result) {
            _this.log('sendNotificationToTeachers# sendEmail# ok', result);
        })
            .catch(function (err) {
            _this.log('sendNotificationToTeachers# sendEmail# error:', err);
        });
    };
    QuestionProviderImpl.prototype.sendNotificationToStudentAndOtherTeachers = function (sender, teachers, question, comment) {
        var _this = this;
        this.log('sendNotificationToStudent#', sender);
        var receivers = [];
        teachers.forEach(function (t) {
            if (t !== sender.email) {
                receivers.push(t);
            }
        });
        receivers.push(question.reporter.email);
        this.log('sendNotificationToStudent# receivers:', receivers);
        CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .sendEmail(teachers, "\u8001\u5E2B ".concat(sender.displayName, " \u56DE\u8986\u4E86 \u554F\u984C[").concat(question.title, "]"), "<div>\u767C\u554F\u8005:".concat(question.reporter.displayName ? question.reporter.displayName : question.reporter.email, "</div>") +
            "<div>\u767C\u554F\u8005 Email:".concat(question.reporter.email, "</div><p/>") +
            "<div>\u8AB2\u7A0B: ".concat(question.courseInfo.courseTitle, "</div><p/>") +
            "<div>\u554F\u984C\u6A19\u984C:<br/>".concat(question.title, "</div><p/>") +
            "<div>\u554F\u984C\u5167\u5BB9:<br/>".concat(question.content, "</div>") +
            "<div>\u56DE\u8986\u8A0A\u606F:<br/>".concat(comment, "</div>"))
            .then(function (result) {
            _this.log('sendNotificationToStudent# sendEmail# ok', result);
        })
            .catch(function (err) {
            _this.log('sendNotificationToStudent# sendEmail# error:', err);
        });
    };
    QuestionProviderImpl.prototype.getComments = function (courseId, studentId, questionId) {
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!studentId || studentId.trim().length === 0) {
            return Promise.reject('studentId cannot be empty!');
        }
        if (!questionId || questionId.trim().length === 0) {
            return Promise.reject('questionId cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "/units/".concat(currentUser.unit, "/question-comments/").concat(courseId, "/").concat(studentId, "/").concat(questionId);
        (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) {
            var comments = [];
            snapshot.forEach(function (childSnapshot) {
                comments.push(childSnapshot.val());
            });
            comments.sort(function (a, b) { return a.updated - b.updated; });
            future.resolve(comments);
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    QuestionProviderImpl.prototype.updateComment = function (courseId, studentId, questionId, comment) {
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!studentId || studentId.trim().length === 0) {
            return Promise.reject('studentId cannot be empty!');
        }
        if (!questionId || questionId.trim().length === 0) {
            return Promise.reject('questionId cannot be empty!');
        }
        if (!comment) {
            return Promise.reject('comment cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "/units/".concat(currentUser.unit, "/question-comments/").concat(courseId, "/").concat(studentId, "/").concat(questionId, "/").concat(comment.id);
        (0, FirebaseUtils_1.setNode)(path, comment)
            .then(function () {
            future.resolve();
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    QuestionProviderImpl.prototype.updateCommentAsRead = function (courseId, reporterId, questionId, commentId) {
        var _this = this;
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!reporterId || reporterId.trim().length === 0) {
            return Promise.reject('reporterId cannot be empty!');
        }
        if (!questionId || questionId.trim().length === 0) {
            return Promise.reject('questionId cannot be empty!');
        }
        if (!commentId || commentId.trim().length === 0) {
            return Promise.reject('commentId cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "/units/".concat(currentUser.unit, "/question-comments/").concat(courseId, "/").concat(reporterId, "/").concat(questionId, "/").concat(commentId, "/read");
        (0, FirebaseUtils_1.setNode)(path, true)
            .then(function () {
            _this.updateQuestionUnreadCount(courseId, reporterId, questionId)
                .then(function () { return future.resolve(); })
                .catch(function (err) { return future.reject(err); });
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    QuestionProviderImpl.prototype.buildQuestion = function (courseInfo, reporter, title, content, resUrl) {
        if (!courseInfo) {
            return Promise.reject('courseInfo cannot be empty!');
        }
        var courseId = courseInfo.courseId, lessonId = courseInfo.lessonId, exerciseId = courseInfo.exerciseId;
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!lessonId || lessonId.trim().length === 0) {
            return Promise.reject('lessonId cannot be empty!');
        }
        if (!exerciseId || exerciseId.trim().length === 0) {
            return Promise.reject('exerciseId cannot be empty!');
        }
        if (!reporter) {
            return Promise.reject('reporter cannot be empty!');
        }
        var uid = reporter.uid, displayName = reporter.displayName;
        if (!uid || uid.trim().length === 0) {
            return Promise.reject('uid cannot be empty!');
        }
        if (!displayName || displayName.trim().length === 0) {
            return Promise.reject('displayName cannot be empty!');
        }
        if ((!title || title.trim().length === 0) && (!content || content.trim().length === 0)) {
            return Promise.reject('title and content cannot be empty at the same time!');
        }
        var participants = [];
        return {
            id: (0, uuid_1.v4)(),
            courseId: courseId,
            lessonId: lessonId,
            exerciseId: exerciseId,
            courseInfo: courseInfo,
            title: title ? title : '',
            content: content ? content : '',
            creator: uid,
            reporter: reporter,
            participants: participants,
            resUrl: resUrl ? resUrl : '',
            updated: firebase_1.default.database.ServerValue.TIMESTAMP,
            readByStudent: false,
            readByTeacher: false,
            resolved: false,
            likes: 0,
            views: 0,
            unreadCount: 0,
            unreadStudentCount: 0,
            unreadTeacherCount: 0,
            lastUpdated: firebase_1.default.database.ServerValue.TIMESTAMP,
            updateUser: {
                uid: reporter.uid,
                displayName: reporter.displayName,
                role: reporter.role,
                email: reporter.email
            }
        };
    };
    QuestionProviderImpl.prototype.createQuestion = function (courseInfo, reporter, title, content, resUrl) {
        var _this = this;
        if (!courseInfo) {
            return Promise.reject('courseInfo cannot be empty!');
        }
        var courseId = courseInfo.courseId, lessonId = courseInfo.lessonId, exerciseId = courseInfo.exerciseId;
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!lessonId || lessonId.trim().length === 0) {
            return Promise.reject('lessonId cannot be empty!');
        }
        if (!exerciseId || exerciseId.trim().length === 0) {
            return Promise.reject('exerciseId cannot be empty!');
        }
        if (!reporter) {
            return Promise.reject('reporter cannot be empty!');
        }
        var uid = reporter.uid, displayName = reporter.displayName;
        if (!uid || uid.trim().length === 0) {
            return Promise.reject('uid cannot be empty!');
        }
        if (!displayName || displayName.trim().length === 0) {
            return Promise.reject('displayName cannot be empty!');
        }
        if ((!title || title.trim().length === 0) && (!content || content.trim().length === 0)) {
            return Promise.reject('title and content cannot be empty at the same time!');
        }
        var question = this.buildQuestion(courseInfo, reporter, title, content, resUrl);
        var currentUser = (0, UserCache_1.loadUser)();
        var path = "/units/".concat(currentUser.unit, "/questions/").concat(courseId, "/").concat(uid, "/").concat(question.id);
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.setNode)(path, question)
            .then(function () {
            (0, FirebaseUtils_1.getNode)("/units/".concat(currentUser.unit, "/courses/").concat(courseId))
                .then(function (snapshot) {
                var course = snapshot.val();
                _this.log('createQuestion# course:', course);
                if (course && course.teachers) {
                    var teachers_1 = [];
                    course.teachers.forEach(function (t) {
                        teachers_1.push(t.email);
                    });
                    CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                        .sendEmail(teachers_1, "".concat(reporter.displayName, " \u5728\u8AB2\u7A0B[").concat(courseInfo.courseTitle, "] \u63D0\u4E86\u4E00\u500B\u554F\u984C!"), "<div>\u767C\u554F\u8005:".concat(reporter.displayName, "</div>") +
                        "<div>\u767C\u554F\u8005 Email:".concat(reporter.email, "</div><p/>") +
                        "<div>\u554F\u984C\u50B3\u9001\u9580:<br/>https://app.codingbar.ai/question/".concat(courseInfo.courseId, "/").concat(reporter.uid, "/").concat(question.id, "</div><p/>") +
                        "<div>\u8AB2\u7A0B: ".concat(courseInfo.courseTitle, "</div><p/>") +
                        "<div>\u55AE\u5143: ".concat(courseInfo.lessonTitle, "</div><p/>") +
                        "<div>\u7FD2\u984C: ".concat(courseInfo.exerciseTitle, "</div><p/>") +
                        "<div>\u554F\u984C\u6A19\u984C:<br/>".concat(question.title, "</div><p/>") +
                        "<div>\u554F\u984C\u5167\u5BB9:<br/>".concat(question.content, "</div>"))
                        .then(function (result) {
                        _this.log('createQuestion# sendEmail# ok', result);
                        future.resolve(question);
                    })
                        .catch(function (err) {
                        _this.log('createQuestion# sendEmail# error:', err);
                        future.resolve(question);
                    });
                }
                else {
                    future.resolve(question);
                }
            })
                .catch(function (err) { return future.reject(err); });
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    QuestionProviderImpl.prototype.getCourseQuestions = function (courseId) {
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('courseId cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "/units/".concat(currentUser.unit, "/questions/").concat(courseId);
        (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) {
            var questions = [];
            snapshot.forEach(function (childSnapshot) {
                var studentQuestions = (0, Utils_1.objectToList)(childSnapshot.val());
                if (studentQuestions) {
                    studentQuestions.forEach(function (question) { return questions.push(question); });
                }
            });
            future.resolve(questions);
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    QuestionProviderImpl.prototype.getStudentQuestions = function (courseId, studentId) {
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('courseId cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "/units/".concat(currentUser.unit, "/questions/").concat(courseId, "/").concat(studentId);
        (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) {
            var questions = [];
            snapshot.forEach(function (childSnapshot) {
                questions.push(childSnapshot.val());
            });
            future.resolve(questions);
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    QuestionProviderImpl.prototype.getAllQuestions = function () {
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "/units/".concat(currentUser.unit, "/questions");
        (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) {
            var questions = [];
            snapshot.forEach(function (courseSnapshot) {
                courseSnapshot.forEach(function (studentSnapshot) {
                    studentSnapshot.forEach(function (questionSnapshot) {
                        questions.push(questionSnapshot.val());
                    });
                });
            });
            future.resolve(questions);
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    QuestionProviderImpl.prototype.getQuestionsByPagination = function (skip, limit, searchType, sort, courseId, searchString) {
        return Promise.resolve([]);
    };
    QuestionProviderImpl.prototype.removeComment = function (courseId, studentId, questionId, commentId) {
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!studentId || studentId.trim().length === 0) {
            return Promise.reject('studentId cannot be empty!');
        }
        if (!questionId || questionId.trim().length === 0) {
            return Promise.reject('questionId cannot be empty!');
        }
        if (!commentId || commentId.trim().length === 0) {
            return Promise.reject('commentId cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "/units/".concat(currentUser.unit, "/question-comments/").concat(courseId, "/").concat(studentId, "/").concat(questionId, "/").concat(commentId);
        (0, FirebaseUtils_1.removeNode)(path)
            .then(function () {
            future.resolve();
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    QuestionProviderImpl.prototype.removeQuestion = function (courseId, creator, questionId) {
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!creator || creator.trim().length === 0) {
            return Promise.reject('creator cannot be empty!');
        }
        if (!questionId || questionId.trim().length === 0) {
            return Promise.reject('questionId cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "/units/".concat(currentUser.unit, "/questions/").concat(courseId, "/").concat(creator, "/").concat(questionId);
        (0, FirebaseUtils_1.removeNode)(path)
            .then(function () {
            path = "/units/".concat(currentUser.unit, "/question-comments/").concat(courseId, "/").concat(creator, "/").concat(questionId);
            (0, FirebaseUtils_1.removeNode)(path)
                .then(function () {
                future.resolve();
            })
                .catch(function (err) { return future.reject(err); });
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    QuestionProviderImpl.prototype.updateLikes = function (questionId) {
        return undefined;
    };
    QuestionProviderImpl.prototype.updateQuestion = function (question) {
        if (!question) {
            return Promise.reject('question cannot be undefined!');
        }
        var id = question.id, courseId = question.courseId, reporter = question.reporter;
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!reporter || !reporter.uid || reporter.uid.trim().length === 0) {
            return Promise.reject('reporter cannot be empty!');
        }
        if (!id || id.trim().length === 0) {
            return Promise.reject('questionId cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "/units/".concat(currentUser.unit, "/questions/").concat(courseId, "/").concat(reporter.uid, "/").concat(id);
        (0, FirebaseUtils_1.setNode)(path, question)
            .then(function () {
            future.resolve();
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    QuestionProviderImpl.prototype.updateReadByStudent = function (courseId, creator, questionId, read) {
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!creator || creator.trim().length === 0) {
            return Promise.reject('creator cannot be empty!');
        }
        if (!questionId || questionId.trim().length === 0) {
            return Promise.reject('questionId cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "/units/".concat(currentUser.unit, "/questions/").concat(courseId, "/").concat(creator, "/").concat(questionId, "/readByStudent");
        (0, FirebaseUtils_1.setNode)(path, read)
            .then(function () {
            future.resolve();
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    QuestionProviderImpl.prototype.updateReadByTeacher = function (courseId, creator, questionId, read) {
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!creator || creator.trim().length === 0) {
            return Promise.reject('creator cannot be empty!');
        }
        if (!questionId || questionId.trim().length === 0) {
            return Promise.reject('questionId cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "/units/".concat(currentUser.unit, "/questions/").concat(courseId, "/").concat(creator, "/").concat(questionId, "/readByTeacher");
        (0, FirebaseUtils_1.setNode)(path, read)
            .then(function () {
            future.resolve();
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    QuestionProviderImpl.prototype.updateResolved = function (courseId, creator, questionId, resolved) {
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!creator || creator.trim().length === 0) {
            return Promise.reject('creator cannot be empty!');
        }
        if (!questionId || questionId.trim().length === 0) {
            return Promise.reject('questionId cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "/units/".concat(currentUser.unit, "/questions/").concat(courseId, "/").concat(creator, "/").concat(questionId, "/resolved");
        (0, FirebaseUtils_1.setNode)(path, resolved)
            .then(function () {
            future.resolve();
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    QuestionProviderImpl.prototype.updateViews = function (questionId) {
        return undefined;
    };
    QuestionProviderImpl.prototype.startListenConversation = function (courseId, studentId, questionId, listener) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        if (!courseId || courseId.trim() === '') {
            this.log('startListenConversation#', 'courseId cannot be empty!');
            return;
        }
        if (!studentId || studentId.trim() === '') {
            this.log('startListenConversation#', 'studentId cannot be empty!');
            return;
        }
        if (!questionId || questionId.trim() === '') {
            this.log('startListenConversation#', 'questionId cannot be empty!');
            return;
        }
        if (!listener) {
            this.log('startListenConversation#', 'listener cannot be empty!');
            return;
        }
        var path = "/units/".concat(currentUser.unit, "/question-comments/").concat(courseId, "/").concat(studentId, "/").concat(questionId);
        this.log('startListenConversation#', path);
        this.dataSyncProvider
            .unsubscribe(this.nodeListenConversation)
            .then(function () {
            var dataSyncListener = {
                onChanged: function (data) {
                    var comments = data ? (0, Utils_1.objectToList)(data) : [];
                    listener.onChanged(comments);
                }
            };
            _this.dataSyncProvider
                .subscribe(path, path, dataSyncListener)
                .then(function (dataSyncNode) {
                _this.nodeListenConversation = dataSyncNode;
            })
                .catch(function (err) { return _this.log(err); });
        })
            .catch(function (err) { return _this.log(err); });
    };
    QuestionProviderImpl.prototype.isStudent = function (sender, studentId) {
        if (sender.uid) {
            if (sender.uid === studentId) {
                return true;
            }
            return false;
        }
        else {
            if (sender === studentId) {
                return true;
            }
            return false;
        }
    };
    QuestionProviderImpl.prototype.updateQuestionUnreadCount = function (courseId, creator, questionId) {
        var _this = this;
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!creator || creator.trim().length === 0) {
            return Promise.reject('creator cannot be empty!');
        }
        if (!questionId || questionId.trim().length === 0) {
            return Promise.reject('questionId cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        this.getComments(courseId, creator, questionId)
            .then(function (comments) {
            var unreadStudentCount = 0;
            var unreadTeacherCount = 0;
            if (comments) {
                var unreadStudentComments = comments.filter(function (c) { return _this.isStudent(c.sender, creator) && !c.read; });
                unreadStudentCount = unreadStudentComments ? unreadStudentComments.length : 0;
                var unreadTeacherComments = comments.filter(function (c) { return !_this.isStudent(c.sender, creator) && !c.read; });
                unreadTeacherCount = unreadTeacherComments ? unreadTeacherComments.length : 0;
            }
            var path = "/units/".concat(currentUser.unit, "/questions/").concat(courseId, "/").concat(creator, "/").concat(questionId, "/unreadStudentCount");
            (0, FirebaseUtils_1.setNode)(path, unreadStudentCount)
                .then(function () {
                path = "/units/".concat(currentUser.unit, "/questions/").concat(courseId, "/").concat(creator, "/").concat(questionId, "/unreadTeacherCount");
                (0, FirebaseUtils_1.setNode)(path, unreadTeacherCount)
                    .then(function () {
                    future.resolve();
                })
                    .catch(function (err) { return future.reject(err); });
            })
                .catch(function (err) { return future.reject(err); });
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    QuestionProviderImpl.prototype.stopListenConversation = function (courseId, studentId, questionId) {
        var _this = this;
        this.dataSyncProvider
            .unsubscribe(this.nodeListenConversation)
            .then(function () {
            _this.log('stopListenConversation# done');
        })
            .catch(function (err) { return _this.log(err); });
    };
    QuestionProviderImpl.prototype.stopAllMonitor = function () {
        var _this = this;
        this.dataSyncProvider
            .unsubscribe(this.nodeListenConversation)
            .then(function () {
            _this.log('stopListenConversation# done');
        })
            .catch(function (err) { return _this.log(err); });
    };
    return QuestionProviderImpl;
}());
exports.QuestionProviderImpl = QuestionProviderImpl;
//# sourceMappingURL=QuestionProviderImpl.js.map